import { createFileRoute } from "@tanstack/react-router"
import { projectEditFormSubmissionViewStaticData } from "src/views/ProjectEditFormSubmissionView/constants"
import { ProjectEditFormSubmissionView } from "src/views/ProjectEditFormSubmissionView/ProjectEditFormSubmissionView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/submissions/$formSubmissionId/edit",
)({
	component: ProjectEditFormSubmissionView,
	staticData: projectEditFormSubmissionViewStaticData,
})
